import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { Breadcrumbs } from '@actualtysoft/ui-kit';
import { Box } from '@mui/material';
import { flatRoutes } from 'plugins/router';

const BreadcrumbComponent = (): JSX.Element => {
  const { pathname } = useLocation();

  const activeRoute = useMemo(
    () => flatRoutes.find(({ path }) => pathname === path),
    [pathname],
  );

  return (
    <>
      {activeRoute?.ancestors.map((route) => (
        <Box key={route.name}>
          {route.name === 'Mon dashboard' ? (
            <Box key={route.name}></Box>
          ) : (
            <Breadcrumbs
              links={[{ title: 'Dashboard', link: '/' }]}
              currentPage={route.name}
            />
          )}
        </Box>
      ))}
    </>
  );
};

export default BreadcrumbComponent;
